import templateUrl from './edit-payroll-invoice-policy-modal.component.html';

export const EditPayrollInvoicePolicyModalComponent = {
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controllerAs: "vm",
    controller: class EditPayrollInvoicePolicyController {
        constructor ($q, utilityService) {
            'ngInject';
            this.$q = $q;
            this.utilityService = utilityService;
        }

        $onInit() {
            this.payrollInvoicePolicy = this.resolve.payrollInvoicePolicy;
        }

        onSave() {
            const saved = this.$q.when()
                .then(() => {
                    return this.resolve.saveFn(this.payrollInvoicePolicy)
                })
                .then(policy => {
                    this.close({ $value: this.payrollInvoicePolicy });
                });

            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(saved, "Save failed")
            );
        }

        onCancel() {
            this.dismiss({ $value: 'cancel' });
        }
    }
}

export const EditPayrollInvoicePolicyModal = {
    component: "apexEditPayrollInvoicePolicyModal"
};
